<app-menu-nav></app-menu-nav>
<router-outlet></router-outlet>
<app-footer></app-footer>